<template>
  <v-dialog v-model="dialog" width="720px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase">
        Sửa phân công chủ nhiệm
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pt-5">
        <div>
          <p class="mb-0">Lớp</p>
          <p>{{ ownClass | _get('title') }}</p>
        </div>

        <div class="mt-3 mb-3">
          <span>Giáo viên chủ nhiệm hiện tại</span>
        </div>

        <v-form ref="form">
          <v-row>
            <v-col cols="12" md="5" class="d-flex flex-column justify-start">
              <div v-if="currentHeadTeachers && currentHeadTeachers.length">
                <div v-for="t in currentHeadTeachers" :key="t.id" class="mb-2">
                  <CardTeacherName :teacher="t" />
                </div>
              </div>
              <p class="mb-0" v-else>Chưa có phân công</p>
            </v-col>

            <v-col cols="12" md="1" class="d-flex justify-center align-center">
              <v-icon large>mdi-arrow-right</v-icon>
            </v-col>

            <v-col cols="12" md="6" class="py-0 d-flex align-center">
              <div style="width:100%">
                <div style="height:8px" />
                <AutocompleteTeacherCardMany
                  ref="autoCompleteTeacherCardMany"
                  v-model="selectedTeachersLocal"
                  label="Giáo viên mới"
                  outlined
                  dense
                  :displayGender="true"
                  class="required"
                  required
                  :rules="rules"
                />
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-text>
        <div>
          <span style="color:red">*</span> Sau khi chuyển phân công chủ nhiệm, giáo viên chủ nhiệm cũ sẽ không thể theo
          dõi thông tin của lớp học cũng như không có quyền xử lý các thông tin liên quan đến lớp. Thay vào đó, giáo
          viên chủ nhiệm mới sẽ tiếp nhận các quyền nêu trên. Vui lòng chú ý khi thực hiện thao tác này
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined class="grey--text" @click="cancel">HUỶ</v-btn>
        <v-btn color="primary" :loading="loading" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'
import AutocompleteTeacherCardMany from '@/components/basic/input/AutocompleteTeacherCardMany.vue'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { uniqBy } from 'lodash'

export default {
  name: 'EditHeadTeachersDialog',
  components: {
    CardTeacherName,
    AutocompleteTeacherCardMany
  },
  props: {
    state: Boolean,
    selectedTeachers: {
      type: Array,
      default: () => []
    },
    ownClass: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      selectedTeachersLocal: [],
      rules: [
        value => {
          if (!value || !value.length) return 'Vui lòng chọn ít nhất 1 giáo viên'
          return true
        }
      ],
    }
  },
  computed: {
    ...mapGetters('app', ['currentSchoolYear']),
    currentHeadTeachers() {
      return this.ownClass && this.ownClass.headTeachers ? this.ownClass.headTeachers : []
    }
  },
  methods: {
    ...mapActions('ownClassTeacher', ['updateClass', 'updateMessageGroup']),
    async save() {
      try {
        if (!this.$refs.form.validate()) {
          return
        }
        this.loading = true
        let newHeadTeachers = uniqBy(this.selectedTeachersLocal || [], 'id')
        if (!newHeadTeachers.length) {
          newHeadTeachers = []
        }

        const metadata = {
          ...this.ownClass.metadata
        }

        const yearId = this.currentSchoolYear && this.currentSchoolYear.id
        const now = moment().toISOString()
        if (yearId) {
          newHeadTeachers.forEach(t => {
            if (t && t.id) {
              metadata[`${t.id}-${yearId}`] = now
            }
          })
        }

        const payload = {
          id: this.ownClass.id,
          headTeachers: newHeadTeachers,
          metadata
        }

        const c = await this.updateClass(payload)

        await this.updateMessageGroup({
          classData: c
        })

        this.$alert.success('Cập nhật chủ nhiệm thành công')
        this.dialog = false
        this.$emit('done', c)
      } catch (error) {
        console.error(error)
        this.$alert.updateError()
      } finally {
        this.loading = false
      }
    },

    refeshAutoCompleteTeacher() {
      this.$refs.autoCompleteTeacherCardMany && this.$refs.autoCompleteTeacherCardMany.fetchAllTeachersFromParent()
    },

    cancel() {
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      if (state) {
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.reset()
        })
        if (this.selectedTeachers && this.selectedTeachers.length) {
          this.selectedTeachersLocal = [...this.selectedTeachers]
        } else if (this.ownClass && this.ownClass.headTeachers && this.ownClass.headTeachers.length) {
          this.selectedTeachersLocal = [...this.ownClass.headTeachers]
        } else {
          this.selectedTeachersLocal = []
        }
        this.dialog = true
      } else {
        this.dialog = false
      }
    },

    selectedTeachers(val) {
      this.selectedTeachersLocal = val ? [...val] : []
    },

    ownClass: {
      handler(nv) {
        if (nv && nv.headTeachers) {
          this.selectedTeachersLocal = [...nv.headTeachers]
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
